
import './App.css';
import Header from './components/Header';
import Container from './components/Container';


function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Container />
       
      </main>
      

    
      
    </div>
  );
}

export default App;
